export default __webpack_public_path__ + "static/media/corpo.15829676.png";